'use strict';

var Class      = require('../util/class'),
    Deferrable = require('../mixins/deferrable');

module.exports = Class(Deferrable);



/*****************
 ** WEBPACK FOOTER
 ** ./src/protocol/publication.js
 ** module id = 35
 ** module chunks = 0
 **/